(() => {
  const desktopMedia = window.matchMedia('(min-width: 53rem)');

  function syncFooter(footer) {
    const details = footer.querySelectorAll('.footer-column > details');
    details.forEach((item) => {
      item.open = desktopMedia.matches;
    });
  }

  function initFooters(root = document) {
    root.querySelectorAll('.site-footer').forEach((footer) => {
      if (footer.dataset.footerReady === 'true') return;
      footer.dataset.footerReady = 'true';
      syncFooter(footer);
    });
  }

  desktopMedia.addEventListener('change', () => {
    document.querySelectorAll('.site-footer').forEach(syncFooter);
  });

  document.addEventListener('shopify:section:load', (event) => initFooters(event.target));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initFooters(), { once: true });
  } else {
    initFooters();
  }
})();
